import styled, { css } from 'styled-components';
import VideoPlayer, { PlayBlobContainer, PlayIconContainer } from 'src/components/VideoPlayer';

export const Panel = styled.div(
  ({ theme }) => css`
    position: relative;
    height: 100%;
    overflow: hidden;
    background-color: ${theme.co.neutral10};
  `,
);

export const Video = styled(VideoPlayer)(
  ({ theme }) => css`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;

    video {
      width: 100%;
      height: 100%;
      max-width: none;
      object-fit: cover;
      object-position: 50% 20%;
      border-radius: 0;
    }

    [data-testid='playButton'] {
      padding: 0;
    }

    ${PlayBlobContainer} {
      display: none;
    }

    ${PlayIconContainer} {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      width: ${theme.sz.s14};
      height: ${theme.sz.s14};
      padding: ${theme.sz.s4} ${theme.sz.s4} ${theme.sz.s4} ${theme.sz.s5};
      border-radius: ${theme.bo.round};
      background-color: hsla(0, 0%, 0%, 0.55);

      svg * {
        fill: ${theme.co.neutral99};
      }
    }
  `,
);

export const PlaybackProgress = styled.div.attrs<{ $fraction: number }>(({ $fraction }) => ({
  style: { transform: `scaleX(${$fraction})` },
}))<{ $fraction: number }>(
  ({ theme }) => css`
    position: absolute;
    inset-inline: 0;
    bottom: 0;
    height: ${theme.sz.s1};
    background-color: ${theme.co.primary20};
    transform-origin: left;
    pointer-events: none;

    [dir='rtl'] & {
      transform-origin: right;
    }
  `,
);
